@if (dataSubjects.length > 0) {
    <div>
        <div class="row datasubjects-header">
            <div class="col-6">{{ 'dataStructures.dataSubjectColumnHeader' | t }}</div>
            <div class="col-6">{{ 'dataStructures.connectedDataStructuresColumnHeader' | t }}</div>
        </div>
        @for (dataSubject of dataSubjects; track dataSubject) {
            <div class="row datasubjects-body">
                <div class="col-6 name">{{ dataSubject.name }}</div>
                <div class="col-6">
                    <button
                        type="button"
                        [disabled]="dataSubject.dataStructures.length === 0"
                        class="btn btn-raised btn-block"
                        [class.green]="dataSubject.dataStructures.length > 0"
                        (click)="viewDataStructures(dataSubject)"
                    >
                        @if (dataSubject.dataStructures.length > 0) {
                            <span
                                >{{ 'dataStructures.viewDataStructures' | t: { count: dataSubject.dataStructures.length } }}</span
                            >
                        } @else {
                            <span [title]="'dataStructures.manageDataToSelectTitle' | t"
                                >{{ 'dataStructures.noDataStructures' | t }}</span
                            >
                        }
                    </button>
                </div>
            </div>
        }
    </div>
}
